import { exportJSON } from '../lib/export';
import type { Catalog } from '../lib/views';
import { isConfigured, supabase } from '../sync/supabase';

interface Props {
  catalog: Catalog;
  onNewList: () => void;
}

/**
 * Deliberately thin. The brief keeps settings out of scope — there is one user,
 * permanently signed in — so this is a place for the handful of things that
 * genuinely have nowhere else to live, not a preferences surface.
 */
export function Settings({ catalog, onNewList }: Props) {
  return (
    <div className="pane">
      <header className="pane__head">
        <div className="pane__heading">
          <h1 className="pane__title">Settings</h1>
        </div>
      </header>

      <div className="pane__scroll">
        <div className="pane__section">
          <div className="section-head" style={{ padding: '0 var(--panel-pad)' }}>
            <span>Organisation</span>
          </div>
          <SettingRow label="Lists" value={`${catalog.lists.length}`} action="New list" onAction={onNewList} />
          <SettingRow label="List tags" value={`${catalog.listTags.length}`} />
          <SettingRow label="Global tags" value={`${catalog.globalTags.length}`} />
        </div>

        <div className="pane__section">
          <div className="section-head" style={{ padding: '0 var(--panel-pad)' }}>
            <span>Data</span>
          </div>
          <SettingRow
            label="Export"
            value="Everything as JSON"
            action="Export"
            onAction={() => void exportJSON()}
          />
          <SettingRow
            label="Sync"
            value={isConfigured ? 'Supabase, this device' : 'Local only'}
            action={isConfigured ? 'Sign out' : undefined}
            onAction={isConfigured ? () => void supabase?.auth.signOut() : undefined}
          />
        </div>

        <div className="pane__section">
          <div className="section-head" style={{ padding: '0 var(--panel-pad)' }}>
            <span>Theme</span>
          </div>
          <SettingRow label="Appearance" value="Dark only" />
        </div>
      </div>
    </div>
  );
}

function SettingRow({
  label,
  value,
  action,
  onAction,
}: {
  label: string;
  value: string;
  action?: string;
  onAction?: () => void;
}) {
  return (
    <div className="row row--tall">
      <div className="row__body">
        <div className="row__title">{label}</div>
        <div className="row__meta">{value}</div>
      </div>
      {action && onAction && (
        <button type="button" className="statusbar__action" onClick={onAction}>
          {action}
        </button>
      )}
    </div>
  );
}
